import { Component, Input } from "@angular/core";

@Component({
  standalone: false,
  selector: "app-avatar",
  templateUrl: "./avatar.component.html",
  styleUrls: ["./avatar.component.scss"]
})
export class AvatarComponent {
  @Input() name?: string;
  @Input() email?: string;
  @Input() src?: string;
  @Input() size: number = 32;

  get hasImage(): boolean {
    return !!this.src;
  }

  get initials(): string {
    const source = (this.name || this.email || "").trim();
    if (!source) return "";
    const parts = source.split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] || "";
    const second = parts.length > 1 ? parts[parts.length - 1]?.[0] : source.length > 1 ? source[1] : "";
    return (first + second).toUpperCase();
  }

  // Deterministic pastel background from text hash
  get bgColor(): string {
    const text = (this.name || this.email || "").toLowerCase();
    let hash = 0;
    for (let i = 0; i < text.length; i++) hash = (hash << 5) - hash + text.charCodeAt(i);
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 55%, 65%)`;
  }
}
